import type { InterventionDefinitionViewModel } from '@generated';

export function getSuggestedInterventionDefinitions(
	findingConceptIds: string[],
	interventionDefinitions: InterventionDefinitionViewModel[]
): InterventionDefinitionViewModel[] {
	return interventionDefinitions.filter(x => x.recommendedFindingConceptIds.some(y => findingConceptIds.includes(y)));
}
